import TickerPower from './TickerPower.jsx';

export default TickerPower;